import { UtilityServices } from "../../../core/services/UtilityServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import React, { useState } from "react";
import { Button } from "rsuite";
import { useTranslation } from "react-i18next";

const CompanyBulkAction = ({
  checkedKeys,
  setCheckedKeys,
  onExportCompany,
  ...props
}: {
  checkedKeys: any;
  setCheckedKeys: Function;
  onExportCompany: any;
}) => {
  const { t } = useTranslation();
  const [openExportCompanyModal, setOpenExportCompanyModal] = useState(false);

  return (
    <div className="company-action col-md-8">
      {UtilityServices.hasPermission("export-company") && (
        <Button onClick={() => setOpenExportCompanyModal(true)}>
          {t("EXPORT")}
        </Button>
      )}

      <AlertModal
        open={openExportCompanyModal}
        handleClose={(e: any) => {
          if (e == true) {
            onExportCompany();
            setOpenExportCompanyModal(false);
          } else {
            setOpenExportCompanyModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION_ALL", {
          action: t("EXPORT").toLowerCase(),
          entity: t("COMPANY").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("EXPORT").toLowerCase(),
        })}
      />
    </div>
  );
};

export default CompanyBulkAction;
